import React from "react";
import { useParams } from "react-router-dom";
import View from "../../View";
import { Card, Row, Col, Tag, Table } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

function MetricDetails() {
  const { run_id, name, predicted_feature, demographic, majority_class } = useParams();

  const randomDate = (date1, date2) => {
    function randomValueBetween(min, max) {
      return Math.random() * (max - min) + min;
    }
    var startDate = date1 || "01-01-1970";
    var endDate = date2 || new Date().toLocaleDateString();
    startDate = new Date(startDate).getTime();
    endDate = new Date(endDate).getTime();
    if (startDate > endDate) {
      return new Date(randomValueBetween(endDate, startDate)).toLocaleDateString();
    } else {
      return new Date(randomValueBetween(startDate, endDate)).toLocaleDateString();
    }
  };

  const columns = [
    {
      title: "Metric",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      align: "center",
    },
  ];

  const data = [
    {
      name: "Equal Opportunity",
      value: "14%",
    },
    {
      name: "Demographic Parity",
      value: "20%",
    },
    {
      name: "Equal Odds",
      value: "14%",
    },
    {
      name: "Individual Fairness",
      value: "N/A",
    },
    {
      name: "Accuracy",
      value: "88.87%",
    },
    {
      name: "Equal Odds TRP",
      value: "14%",
    },
    {
      name: "Equal Odds TNR",
      value: "-7%",
    },
  ];

  return (
    <View>
      <Row gutter={16}>
        <Col span={12}>
          <Card title="Pipeline Details" style={{ paddingBottom: "3px" }}>
            <Row gutter={16}>
              <Col span={12} style={{ fontWeight: "bold" }}>
                <p>Pipeline Number</p>
                <p>Pipeline Name</p>
                <p>Start Date</p>
                <p>User</p>
                <p>Status</p>
              </Col>
              <Col span={12}>
                <p>{run_id}</p>
                <p>{name}</p>
                <p>03 March 2021 (13:52)</p>
                <p>Raluca</p>
                <p>
                  {run_id % 2 !== 0 && (
                    <Tag color="green">
                      <CheckOutlined /> Completed
                    </Tag>
                  )}
                  {run_id % 2 === 0 && (
                    <Tag color="red">
                      <CloseOutlined /> Running
                    </Tag>
                  )}
                </p>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Pipeline Inputs">
            <Row gutter={16}>
              <Col span={12} style={{ fontWeight: "bold" }}>
                <p>Dataset</p>
                <p>Model</p>
                <p>Predicted Feature</p>
                <p>Demographic</p>
                <p>Majority Class</p>
              </Col>
              <Col span={12}>
                <p>dataset</p>
                <p>N/A</p>
                <p>
                  <Tag color="geekblue">{predicted_feature}</Tag>
                </p>
                <p>
                  <Tag color="volcano">{demographic}</Tag>
                </p>
                <p>
                  <Tag color="green">{majority_class}</Tag>
                </p>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <br />
      <Row gutter={16}>
        <Col span={24}>
          <Card title="Pipeline Metrics">
            <Table columns={columns} dataSource={data}></Table>
          </Card>
        </Col>
      </Row>
    </View>
  );
}

export default MetricDetails;
